<template>
  <div>
    <div
      class="back-button-container"
      aria-label="Go back"
      @click="goBack"
    >
      <div class="back-button">
        <svg
          class="arrow"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line
            x1="19"
            y1="12"
            x2="5"
            y2="12"
          />
          <polyline points="12 19 5 12 12 5" />
        </svg>
      </div>
      <span class="back-text">Back</span>
    </div>

    <img
      src="../assets/logo.png"
      class="logo-who"
      alt="ICMSS 2021"
      @click="goToSplash"
    >

    <div class="text-wrapper">
      <h1 class="title is-size-2-mobile">
        Hello!
      </h1>

      <div class="form-container">
        <h2 class="subtitle is-size-3-mobile input-row">
          <span>My name is</span>
          <input
            v-model="name"
            type="text"
            class="subtitle is-size-3-mobile input-styled"
            placeholder="Enter your name"
          >
        </h2>
        <h2 class="subtitle is-size-3-mobile input-row">
          <span>I'm a</span>
          <select
            v-model="major"
            class="subtitle is-size-3-mobile input-styled select-styled"
            style="margin-bottom: 0"
            required
          >
            <option
              value=""
              disabled
              selected
            >
              Select your major
            </option>
            <option
              v-for="choice in majorChoices"
              :key="choice"
              :value="choice"
              class="select-option-styled is-size-3-mobile"
            >
              {{ choice }}
            </option>
          </select>
          <span>student</span>
        </h2>
        <h2 class="subtitle is-size-3-mobile input-row">
          <span>Here is my email</span>
          <input
            v-model="email"
            type="email"
            class="subtitle is-size-3-mobile input-styled"
            placeholder="Enter your email"
          >
        </h2>
      </div>
    </div>

    <div class="buttons-container">
      <next-button
        v-if="validInfo"
        class="animate-show"
        @click.native="nextStep"
      />
    </div>
  </div>
</template>

<script>
import NextButton from "./NextButton.vue";

export default {
  name: "Who",
  components: {
    NextButton,
  },
  props: {
    userData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      name: this.userData.name || "",
      email: this.userData.email || "",
      major: this.userData.major || "",
      majorChoices: [
        "Management",
        "Economics",
        "Accounting",
        "Islamic Economics",
        "Islamic Business",
      ],
    };
  },
  computed: {
    validInfo() {
      return (
        this.name.length > 0 &&
        this.email.length > 0 &&
        this.major.length > 0 &&
        this.validEmail(this.email)
      );
    },
  },
  methods: {
    nextStep() {
      this.$emit("next-step", {
        name: this.name,
        email: this.email,
        major: this.major,
      });
    },
    goBack() {
      this.$emit("go-to-splash");
    },
    goToSplash() {
      this.$emit("go-to-splash");
    },
    validEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  },
};
</script>

<style scoped>
.back-button-container {
  position: absolute;
  top: 40px;
  left: 40px;
  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 100;
}

.back-button {
  width: 50px;
  height: 50px;
  background-color: rgba(255, 255, 255, 0.15);
  border: 1px solid white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.back-button .arrow {
  width: 24px;
  height: 24px;
  stroke: white;
  stroke-width: 2.5;
  transition: stroke 0.3s ease;
}

.back-text {
  color: white;
  font-size: 1.2rem;
  margin-left: 10px;
  opacity: 0;
  transition: opacity 0.3s ease, transform 0.3s ease;
  transform: translateX(-10px);
}

.back-button-container:hover .back-button {
  background-color: white;
  transform: scale(1.1);
}

.back-button-container:hover .arrow {
  stroke: #000942;
}

.back-button-container:hover .back-text {
  opacity: 1;
  transform: translateX(0);
}

.form-container {
  margin-top: 1rem;
}

.input-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.5rem;
  margin-bottom: 2.5rem;
}

.input-row span {
  white-space: nowrap;
}

.input-styled {
  border: none;
  background: transparent;
  border-bottom: 4px solid #fff;
  color: white;
  outline: none;
  width: 100%;
}

.input-styled::placeholder {
  color: rgba(255, 255, 255, 0.5);
  font-style: italic;
}

.select-styled {
  appearance: none;
  text-transform: capitalize;
}

.select-styled:valid {
  color: white;
}
.select-styled:invalid {
  color: rgba(255, 255, 255, 0.5);
  font-style: italic;
}

.select-option-styled {
  color: #000942;
  text-transform: capitalize;
}

.text-wrapper {
  width: 100%;
}

.buttons-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 2rem;
  position: relative;
  z-index: 50;
}

.buttons-container .next-button {
  position: fixed;
  right: 15%;
  bottom: 100px;
  z-index: 100;
}

@media screen and (max-width: 991px) {
  .back-button-container {
    top: 20px;
    left: 20px;
  }
  
  .back-button {
    width: 45px;
    height: 45px;
    background-color: white;
  }

  .back-button .arrow {
    stroke: #000942;
    transform: rotate(0deg);
  }

  .back-text {
    opacity: 1;
    transform: translateX(0);
    color: white;
  }

  .text-wrapper {
    width: 100%;
  }

  .input-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .input-styled {
    width: 100%;
  }

  .buttons-container .next-button {
    right: 25px;
    bottom: 60px;
  }
}

@media screen and (max-width: 768px) {
  .buttons-container .next-button {
    right: 20px;
    bottom: 50px;
  }
}

@media screen and (max-width: 480px) {
  .buttons-container .next-button {
    right: 15px;
    bottom: 40px;
  }
}

@media screen and (max-height: 500px) and (orientation: landscape) {
  .buttons-container .next-button {
    right: 20px;
    bottom: 20px;
  }
}
</style>

<style scoped>
.logo-who {
  position: absolute;
  top: 35px;
  right: 5%;
  width: auto;
  max-height: 10vh;
  z-index: 100;
  cursor: pointer;
}

@media screen and (max-width: 991px) {
  .logo-who {
    top: 20px;
    right: 20px;
    max-height: 8vh;
  }
}

@media screen and (max-width: 768px) {
  .logo-who {
    top: 15px;
    right: 15px;
    max-height: 7vh;
  }
}

@media screen and (max-width: 480px) {
  .logo-who {
    top: 10px;
    right: 10px;
    max-height: 6vh;
  }
}
</style>
